// Custom field collection
cv.CustomField = Backbone.Model.extend({
  defaults: {
    label: "",
    type: "text_line",
    required: 0,
    checked: 0,
    default_values: "",
    field_style: "",
    group_style: "",
    help_text: "",
    ordinal: 0,
    indexable: 0,
  },

  initialize: function () {
    console.log("CustomField model loaded.");
  },
});

cv.CustomFields = Backbone.Collection.extend({
  initialize: function (model, options) {
    console.log("CustomFields collection loaded.");
  },

  comparator: function (model) {
    return parseInt(model.get("ordinal"), 10);
  },

  model: cv.CustomField,
});

cv.CustomFieldGroup = Backbone.Model.extend({
  defaults: {
    label: "",
    type: "normal",
    field_style: "",
    group_style: "one_column",
    fields: [],
  },

  initialize: function () {
    console.log("CustomFieldGroup model loaded.");
  },
});

cv.CustomFieldGroups = Backbone.Collection.extend({
  initialize: function (model, options) {
    console.log("CustomFieldGroups collection loaded.");
  },

  comparator: function (model) {
    return parseInt(model.get("ordinal"), 10);
  },

  model: cv.CustomFieldGroup,
});
